/**
 * @name GoogleCaptcha.AdvancedSignup.js
 * @author Anchor Group : Kalpa
 * @since 2025-02-13
 * @file Add Google Re-Captcha to advanced signup form.
 */
define('GoogleCaptcha.AdvancedSignup', [
    'CaptchaInAdvancedSignup.View',
    'jQuery',
], function (
    CaptchaInAdvancedSignupView,
    jQuery
) {
    'use strict';
    return {
        loadCaptcha: function (container, captchaConfig) {
            var environment = container.getComponent('Environment'),
            config = environment.getConfig('GoogleCaptcha') || {},
            layout = container.getComponent('Layout');
            if(!config.advancedSignUp){
                return;
            }
            var AdvancedSignUpRegistrationFormView_module = require('SuiteCommerce.AdvancedSignUp.RegistrationForm.View'),
            AdvancedSignUpRegistrationFormView = _.has(AdvancedSignUpRegistrationFormView_module, 'RegistrationFormView')?
                AdvancedSignUpRegistrationFormView_module['RegistrationFormView']:
                AdvancedSignUpRegistrationFormView_module,
            captchaView = new CaptchaInAdvancedSignupView({
                captchaConfig: captchaConfig,
                application: container
            });
            layout.addChildView('RegistrationForm.Fields', function () {
                return captchaView;
            });
            
            if(config.reCaptchaVersion == 'V3'){
                jQuery('<script />', {
                    src: (captchaConfig.apiUrl + "?render=" + captchaConfig.siteKey)
                ,   async: true
                ,   defer: true
                }).appendTo('body');
            }
            AdvancedSignUpRegistrationFormView.prototype.createCustomer = _.wrap(AdvancedSignUpRegistrationFormView.prototype.createCustomer, function(fn){
                var args =  _.toArray(arguments).slice(1),
                event = args.length? args[0]: '',
                self = this;
                if(event){
                    event.preventDefault();
                }
                if(config.reCaptchaVersion == 'V3'){
                    captchaView.validateCaptchaV3().then(function(){
                        fn.apply(self, args);
                    });
                }
                else if(config.reCaptchaVersion == 'V2'){
                    
                    captchaView.validateCaptcha().then(function(){
                        fn.apply(self, args);
                    });
                }
                else{
                
                    return fn.apply(this, _.toArray(arguments).slice(1));
                }
            });
        },
    };
});
